// models
import { Base } from 'app/shared/models/base.model';
import { CustomerSector } from 'app/shared/models/customer-sector.model';
import { OrderService } from 'app/shared/models/order-service.model';
import { Supplier } from 'app/shared/models/supplier.model';
import { InstrumentType } from 'app/shared/models/instrument-type.model';
import { InstrumentModel } from 'app/shared/models/instrument-model.model';
import { Sector } from 'app/shared/models/sector.model';
import { InstrumentBand } from 'app/instruments/shared/instrument-band.model';

export class Instrument extends Base {

  constructor(
    public CalibrationFrequencyMonths?: number,
    public Code?: string,
    public CurrentSector?: Sector,
    public CustomerSector?: CustomerSector,
    public DeliveryDate?: Date,
    public Description?: string,
    public FullBandsDescription?: string,
    public HasAttachment?: Boolean,
    public InstrumentBands?: Array<InstrumentBand>,
    public InstrumentModel?: InstrumentModel,
    public InstrumentType?: InstrumentType,
    public IsActive?: boolean,
    public LastCalibration?: Date,
    public NextCalibration?: Date,
    public OrderService?: OrderService,
    public SerialNumber?: string,
    public ShortBandsDescription?: string,
    public Status?: number,
    public Supplier?: Supplier,
    public Tag?: string,

    // amostra
    public SampleExpirationDate?: Date,
    public CollectDate?: Date,
    public CollectPlaceName?: string,
    public CollectPlace?: boolean
  ) {
    super();
  }
}



// WEBPACK FOOTER //
// ./src/app/instruments/shared/instrument.model.ts